import { useState } from "react";
export var TERRITORY_PRESETS = [
    { key: "today", label: "Today", triggerLabel: "Today", days: 0 },
    { key: "1month", label: "1 month", triggerLabel: "Last 30 days", days: 30 },
    { key: "6weeks", label: "6 weeks", triggerLabel: "Last 6 weeks", days: 42 },
    { key: "2month", label: "2 month", triggerLabel: "Last 2 months", days: 60 },
    { key: "3month", label: "3 month", triggerLabel: "Last 3 months", days: 90 },
];
export function toYMD(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
}
export function fromYMD(ymd) {
    var _a = ymd.split("-").map(Number), y = _a[0], m = _a[1], d = _a[2];
    return new Date(y, m - 1, d);
}
export function formatDisplay(ymd) {
    var d = fromYMD(ymd);
    return "".concat(d.getMonth() + 1, "/").concat(d.getDate(), "/").concat(d.getFullYear());
}
export function addDays(date, n) {
    var r = new Date(date);
    r.setDate(r.getDate() + n);
    return r;
}
export function sameDay(a, b) {
    return (a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate());
}
var MONTH_NAMES = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
];
export function useTerritoryReportsDatePicker(_a) {
    var _b;
    var dateRange = _a.dateRange, selectedPresetKey = _a.selectedPresetKey, onApply = _a.onApply;
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var _d = useState(selectedPresetKey), tempPreset = _d[0], setTempPreset = _d[1];
    var _e = useState(fromYMD(dateRange.startDate)), selStart = _e[0], setSelStart = _e[1];
    var _f = useState(fromYMD(dateRange.endDate)), selEnd = _f[0], setSelEnd = _f[1];
    var _g = useState(false), pickingEnd = _g[0], setPickingEnd = _g[1];
    var _h = useState(null), hover = _h[0], setHover = _h[1];
    var _j = useState(function () {
        var d = fromYMD(dateRange.startDate);
        return { year: d.getFullYear(), month: d.getMonth() };
    }), viewMonth = _j[0], setViewMonth = _j[1];
    var secondView = viewMonth.month === 11
        ? { year: viewMonth.year + 1, month: 0 }
        : { year: viewMonth.year, month: viewMonth.month + 1 };
    var activePreset = TERRITORY_PRESETS.find(function (p) { return p.key === selectedPresetKey; });
    var isCustom = !activePreset;
    var triggerText = isCustom
        ? "".concat(formatDisplay(dateRange.startDate), " - ").concat(formatDisplay(dateRange.endDate))
        : ((_b = activePreset === null || activePreset === void 0 ? void 0 : activePreset.triggerLabel) !== null && _b !== void 0 ? _b : "Custom date");
    var handleOpen = function (e) {
        setAnchorEl(e.currentTarget);
        setTempPreset(selectedPresetKey);
        setSelStart(fromYMD(dateRange.startDate));
        setSelEnd(fromYMD(dateRange.endDate));
        setPickingEnd(false);
        var d = fromYMD(dateRange.startDate);
        setViewMonth({ year: d.getFullYear(), month: d.getMonth() });
    };
    var handleClose = function () { return setAnchorEl(null); };
    var handlePresetClick = function (preset) {
        setTempPreset(preset.key);
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var start = preset.days === 0 ? today : addDays(today, -preset.days);
        setSelStart(start);
        setSelEnd(today);
        setPickingEnd(false);
        setViewMonth({ year: start.getFullYear(), month: start.getMonth() });
    };
    var handleDayClick = function (date) {
        if (!pickingEnd) {
            setSelStart(date);
            setSelEnd(null);
            setPickingEnd(true);
            setTempPreset("custom");
        }
        else {
            if (selStart && date < selStart) {
                setSelEnd(selStart);
                setSelStart(date);
            }
            else {
                setSelEnd(date);
            }
            setPickingEnd(false);
            setTempPreset("custom");
        }
    };
    var handleApply = function () {
        if (!selStart || !selEnd)
            return;
        onApply({ startDate: toYMD(selStart), endDate: toYMD(selEnd) }, tempPreset);
        handleClose();
    };
    var handlePrev = function () {
        return setViewMonth(function (v) { return v.month === 0 ? { year: v.year - 1, month: 11 } : { year: v.year, month: v.month - 1 }; });
    };
    var handleNext = function () {
        return setViewMonth(function (v) { return v.month === 11 ? { year: v.year + 1, month: 0 } : { year: v.year, month: v.month + 1 }; });
    };
    var rangeHeader = function () {
        var fmt = function (d) { return "".concat(MONTH_NAMES[d.getMonth()].slice(0, 3), " ").concat(d.getDate()); };
        if (!selStart)
            return "";
        if (!selEnd)
            return "".concat(fmt(selStart), " \u2013");
        return "".concat(fmt(selStart), " \u2013 ").concat(fmt(selEnd));
    };
    return {
        anchorEl: anchorEl,
        open: open,
        tempPreset: tempPreset,
        selStart: selStart,
        selEnd: selEnd,
        pickingEnd: pickingEnd,
        hover: hover,
        viewMonth: viewMonth,
        secondView: secondView,
        triggerText: triggerText,
        handleOpen: handleOpen,
        handleClose: handleClose,
        handlePresetClick: handlePresetClick,
        handleDayClick: handleDayClick,
        setHover: setHover,
        handleApply: handleApply,
        handlePrev: handlePrev,
        handleNext: handleNext,
        rangeHeader: rangeHeader,
    };
}
